const comprobante = {
  readComprobanteTipos: 'comprobantes-tipo/{{pais}}',
  readComprobante: 'comprobante/{{uuid_comprobante}}',
  readComprobanteByPago: 'comprobante/pago/{{uuid_pago}}',
  readComprobantePdf: 'comprobante/{{uuid_pago}}/pdf'
}

export default comprobante
